(function () {
    window.KocotApp = window.KocotApp || {};

    var contentSelector = '.page-content';
    var currentRequest = null;
    var isLoading = false;
    var fadeDuration = 300;

    function isPlainLeftClick(event) {
        return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    }

    function hasFileExtension(pathname) {
        return /\.(?:7z|avi|css|doc|docx|gif|gz|jpeg|jpg|js|json|mp3|mp4|pdf|png|rar|svg|webp|xls|xlsx|zip)$/i.test(pathname);
    }

    function shouldHandleLink(link, event) {
        if (!link || !link.href || !isPlainLeftClick(event)) {
            return false;
        }

        if (link.target && link.target !== '_self') {
            return false;
        }

        if (link.hasAttribute('download') || link.dataset.ajax === 'false') {
            return false;
        }

        var href = link.getAttribute('href');

        if (!href || href.charAt(0) === '#') {
            return false;
        }

        var url = new URL(link.href, window.location.href);

        if (url.origin !== window.location.origin) {
            return false;
        }

        if (/^(?:mailto|tel|sms):/i.test(url.protocol)) {
            return false;
        }

        if (url.pathname.indexOf('/wp-admin') === 0 || url.pathname.indexOf('/wp-login.php') === 0) {
            return false;
        }

        if (hasFileExtension(url.pathname)) {
            return false;
        }

        return !(url.pathname === window.location.pathname && url.search === window.location.search && url.hash);
    }

    function setLoadingState(value) {
        isLoading = value;
        document.documentElement.classList.toggle('is-ajax-loading', value);
    }

    function fadeOutContent() {
        var content = document.querySelector(contentSelector);

        if (!content) {
            return Promise.resolve();
        }

        content.classList.add('is-fading-out');

        return new Promise(function (resolve) {
            window.setTimeout(resolve, fadeDuration);
        });
    }

    function executeScripts(container) {
        var scripts = Array.from(container.querySelectorAll('script'));

        scripts.forEach(function (script) {
            var freshScript = document.createElement('script');

            Array.from(script.attributes).forEach(function (attribute) {
                freshScript.setAttribute(attribute.name, attribute.value);
            });

            freshScript.text = script.textContent;
            script.parentNode.replaceChild(freshScript, script);
        });
    }

    function initContactForms(container) {
        if (!window.wpcf7 || typeof window.wpcf7.init !== 'function') {
            return;
        }

        container.querySelectorAll('.wpcf7 form').forEach(function (form) {
            window.wpcf7.init(form);
        });
    }

    function refreshAnimations() {
        if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
            window.ScrollTrigger.refresh();
        }
    }

    function initPageContent(container) {
        executeScripts(container);
        initContactForms(container);

        if (window.KocotApp && typeof window.KocotApp.initPage === 'function') {
            window.KocotApp.initPage();
        }

        refreshAnimations();
    }

    function updateNavigation(doc) {
        var currentMenu = document.querySelector('.page-header-nav');
        var nextMenu = doc.querySelector('.page-header-nav');

        if (currentMenu && nextMenu) {
            currentMenu.innerHTML = nextMenu.innerHTML;
        }

        if (window.KocotApp && typeof window.KocotApp.closePageHeader === 'function') {
            window.KocotApp.closePageHeader();
        }
    }

    function updateFooterContact(doc) {
        var footer = document.querySelector('.page-footer');
        var currentContact = footer ? footer.querySelector('.page-footer-contact') : null;
        var nextContact = doc.querySelector('.page-footer-contact');
        var clonedContact = null;

        if (!footer) {
            return null;
        }

        if (currentContact && nextContact) {
            clonedContact = nextContact.cloneNode(true);
            currentContact.replaceWith(clonedContact);
            return clonedContact;
        }

        if (currentContact && !nextContact) {
            currentContact.remove();
            return null;
        }

        if (!currentContact && nextContact) {
            clonedContact = nextContact.cloneNode(true);
            footer.insertBefore(clonedContact, footer.firstElementChild);
            return clonedContact;
        }

        return null;
    }

    function scrollToTop() {
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
            window.lenis.scrollTo(0, { immediate: true });
            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }

    function swapPage(html, url, shouldPushState) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var currentContent = document.querySelector(contentSelector);
        var nextContent = doc.querySelector(contentSelector);

        if (!currentContent || !nextContent) {
            window.location.href = url.href;
            return;
        }

        document.title = doc.title || document.title;
        updateNavigation(doc);
        var nextFooterContact = updateFooterContact(doc);
        currentContent.replaceWith(nextContent);
        initPageContent(nextContent);

        if (nextFooterContact) {
            initContactForms(nextFooterContact);
        }

        scrollToTop();

        if (shouldPushState) {
            window.history.pushState({ ajaxPage: true }, document.title, url.href);
        }
    }

    function loadPage(url, shouldPushState) {
        if (isLoading && currentRequest) {
            currentRequest.abort();
        }

        currentRequest = new AbortController();
        setLoadingState(true);

        return fadeOutContent().then(function () {
            return fetch(url.href, {
            credentials: 'same-origin',
            signal: currentRequest.signal,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            });
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Ajax page request failed.');
                }

                return response.text();
            })
            .then(function (html) {
                swapPage(html, url, shouldPushState);
            })
            .catch(function (error) {
                if (error.name === 'AbortError') {
                    return;
                }

                window.location.href = url.href;
            })
            .finally(function () {
                setLoadingState(false);
                currentRequest = null;
            });
    }

    function onDocumentClick(event) {
        var target = event.target && event.target.closest ? event.target : event.target.parentElement;
        var link = target ? target.closest('a') : null;

        if (!shouldHandleLink(link, event)) {
            return;
        }

        event.preventDefault();

        if (isLoading) {
            return;
        }

        loadPage(new URL(link.href), true);
    }

    function onPopState() {
        loadPage(new URL(window.location.href), false);
    }

    function initAjaxPages() {
        if (document.documentElement.dataset.ajaxPagesInitialized === 'true') {
            return;
        }

        document.documentElement.dataset.ajaxPagesInitialized = 'true';
        document.addEventListener('click', onDocumentClick);
        window.addEventListener('popstate', onPopState);
        window.history.replaceState({ ajaxPage: true }, document.title, window.location.href);
    }

    window.KocotApp.initAjaxPages = initAjaxPages;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAjaxPages);
    } else {
        initAjaxPages();
    }
})();
